import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBqgptAJD8eXT_nEKl_X3Z3AVZmyBYpgno',
  authDomain: 'accessin-code-academy.firebaseapp.com',
  projectId: 'accessin-code-academy',
  storageBucket: 'accessin-code-academy.appspot.com',
  messagingSenderId: '844488835685',
  appId: '1:844488835685:web:b549c0af6a784d0ed67c8c',
  measurementId: 'G-HQX0DGE43B',
};

initializeApp(firebaseConfig);

const db = getFirestore();

// eslint-disable-next-line import/prefer-default-export
export { db };
